import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import TaskEditFormImpl from './TaskEditFormImpl';
import TaskList from './TaskList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import TaskListView from './TaskListView'


export default function TaskDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.taskDashboard);
  const [ taskId, setTaskId] = React.useState('');
  const [reloadTaskList, setReloadTaskList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <TaskEditFormImpl 
            setReloadTaskList={setReloadTaskList}
            taskId={taskId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <TaskListView 
                      setTaskId = {setTaskId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
